import React from "react";

export default function TeamTwo() {
  return (
    <>
      <section id="team" className="team-member-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              
              <div className="section-heading text-center mb-5">
                
                <h2 style={{color:'whitesmoke'}}>Our Team</h2>
                <p style={{color:'whitesmoke'}}>
                The Sustainable Institute is committed to the highest of professional standards and
roots its service offerings in a fundamental value of integrity. We are dedicated to
delivering beyond expectations through promoting partnership, openness, and
responsiveness to client needs. The Sustainable Institute devotes itself to searching for
accomplished, creative, and committed individuals from around the globe who have
the expertise necessary to take on complex and evolving developmental challenges.
Our firm brings in skilled professionals to form diverse teams with both regional and
international experts. This not only adds to the team’s program specialization but also
expands the client’s geographical reach, thus enabling each client to meet their own
unique objectives. At the core of this global network is Sustainable Institute’s
incomparable commitment to local developmental expertise. We work in all areas of
development, from policy and strategic advice to the identification, evaluation,
organization, and management of development projects. The Sustainable Institute
offers the creative expertise it takes to turn brilliant ideas into practical strategies and
provides clients with revenue-generating programs and tactics that benefit society.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
